<template>
  <div class="gradient-value" :style="style">
    <span>${{ parseInt(this.value).toLocaleString() }}</span>
  </div>
</template>

<script>
import { GradientCalculator, TextColorCalculator } from './gradient-calculator'

export default {
  name: 'GradientValue',
  props: {
    value: {
      type: Number,
      description: 'value'
    },
    startColor: {
      type: String,
      description: 'RGB color for the start of the gradient'
    },
    endColor: {
      type: String,
      description: 'RGB color for the end of the gradient'
    },
    endValue: {
      type: Number,
      description: 'Value associated with the end of the gradient'
    }
  },
  data() {
    return {
      steps: 1000
    }
  },
  computed: {
    style() {
      return `background-color: ${this.color};color: ${this.textColor};`
    },
    color() {
      if (this.value === null || this.value === undefined) return this.startColor
      else if (this.value >= this.endValue) return this.endColor
      else return this.calculator.rgbColor(Math.round((this.value / this.endValue) * this.steps))
    },
    textColor() {
      return TextColorCalculator.getTextColor(this.color, '#FFFFFF', '#000000')
    },
    calculator() {
      return new GradientCalculator(this.startColor, this.endColor, this.steps)
    }
  }
}
</script>

<style lang="scss" scoped>
.gradient-value {
  border-radius: 5px 5px 5px 5px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
